/**
 * Shared formatting utilities
 */

/**
 * Formats a price in euro cents as a display string (e.g. 1550 -> "€15.50")
 */
export function formatPrice(cents: number): string {
  return `€${(cents / 100).toFixed(2)}`;
}
